// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"expand_button_expandButton__1DpkJ","arrowIcon":"expand_button_arrowIcon__37l4i","arrowIconInverted":"expand_button_arrowIconInverted__1W2Ee"};